export const TrustQualifiedAsEnum = {
  Trustee: 'TRUSTEE',
} as const satisfies Record<string, string>;
export const TrustQualifiedAsLabels = {
  [TrustQualifiedAsEnum.Trustee]: 'Trustee',
} as const;
export type TrustQualifiedAs =
  (typeof TrustQualifiedAsEnum)[keyof typeof TrustQualifiedAsEnum];
